import React from "react";
// import "./Methodology.css";

const Methodology = () => {
  const cards = [
    {
      icon:  <img
      src="/assets/images/ValuationApproach/Vector.png"
      alt="↗"
    />,
      title: "Customized Valuation Methodology",
      button: null,
    },
    {
      icon:  <img
      src="/assets/images/ValuationApproach/Vector.png"
      alt="↗"
    />,
      title: "Reliable Data Sources",
      button: null,
    },
    {
      icon:  <img
      src="/assets/images/ValuationApproach/Vector.png"
      alt="↗"
    />,
      title:
        "Most valuation platforms use only the DCF (Discounted Cash Flow) approach",
      button: "Know More",
    },
    {
      icon:  <img
      src="/assets/images/ValuationApproach/Vector.png"
      alt="↗"
    />,
      title: "Tailored Valuation Report",
      button: null,
    },
  ];

  return (
    <section className="methodology-section">
    </section>
  );
};

export default Methodology;
